export const Logo = ({ dark = false, className = "" }) => (
    <svg
        viewBox="0 0 40 40"
        className={className}
        role="img"
        aria-label="Steevens Complete Interiors logo"
    >
        <rect width="40" height="40" rx="7" fill={dark ? "#FBF9F5" : "#1C1917"} />
        <path
            d="M27.8 14.6c-1.6-2.1-4.3-3.2-7.3-3.2-4.2 0-7.1 2.1-7.1 5.2 0 6.6 14.8 3.5 14.8 9.7 0 3.1-3.2 5.2-7.6 5.2-3.9 0-7-1.7-8.2-4.3"
            stroke="#D99B53"
            strokeWidth="2.9"
            strokeLinecap="round"
            fill="none"
        />
        <rect x="29.5" y="8.5" width="3.4" height="3.4" fill="#C27D38" />
    </svg>
);

export const Wordmark = ({ dark = false }) => (
    <span className="flex items-center gap-3">
        <Logo dark={dark} className="h-9 w-9 shrink-0" />
        <span className="flex flex-col leading-none">
            <span
                className={`font-serif text-xl font-medium tracking-wide ${
                    dark ? "text-bone" : "text-espresso"
                }`}
            >
                Steevens
            </span>
            <span
                className={`font-mono text-[9px] uppercase tracking-[0.3em] ${
                    dark ? "text-bone/60" : "text-fog"
                }`}
            >
                Complete Interiors
            </span>
        </span>
    </span>
);
